<template>
  <div
    class="relative w-full h-full pb-4 overflow-auto scrollbar scrollbar-small"
    style="scrollbar-gutter:stable"
  >
    <div
      class="bg-white z-10 sticky top-0 grid items-center pb-2"
      :style="tableStyle + ' width:' + tableWidth"
    >
      <table-header
        v-for="(header, index) in headers"
        :key="index"
        :name="header.name"
        :type="header.type"
        :options="header.options"
        v-model="header.value"
        @update:modelValue="filterItems"
      />
    </div>
    <div
      v-for="(item, index) in filteredItems"
      :key="index"
      class="grid border-2 rounded-md"
      :class="[
        itemsSelectable ? 'cursor-pointer' : 'cursor-default',
        index === selectedItemIndex
          ? 'bg-primary-lighter border-primary-light'
          : index % 2 === 0
          ? 'bg-white-dark border-white-dark'
          : 'bg-transparent border-transparent',
      ]"
      :style="tableStyle + ' width:' + tableWidth"
      @click="() => highlightItem(index, item)"
    >
      <table-item
        v-for="(header, headerIndex) in headers"
        :key="headerIndex"
        :item="item"
        :header="header"
        @change="
          (value) =>
            $emit('changeItem', {
              value,
              dbValue: header.dbValue,
              itemId: item.id,
            })
        "
      />
    </div>
  </div>
</template>

<script>
import { computed, defineComponent, onMounted, ref, toRefs, watch } from "vue";
import { getData } from "../../common/dataHelper";
import TableHeader from "./TableHeader.vue";
import TableItem from "./TableItem.vue";

export default defineComponent({
  components: { TableHeader, TableItem },
  props: {
    // e.g. 1200px
    tableWidth: {
      type: String,
      required: true,
    },
    headers: {
      type: Array,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
    itemsSelectable: {
      type: Boolean,
      default: true,
    },
  },
  emits: ["clickItem", "changeItem"],
  setup(props, context) {
    const selectedItemIndex = ref(null);
    const filteredItems = ref([]);

    function highlightItem(index, item) {
      if (!props.itemsSelectable || selectedItemIndex.value === index) return;
      selectedItemIndex.value = index;
      context.emit("clickItem", item);
    }

    function filterItems() {
      filteredItems.value = props.items.filter((item) => {
        const headerFilterAreNotMatching = props.headers.some((header) => {
          let itemValue = getData(item, header.dbValue) ?? "";
          if (
            (!header.type || header.type === "input") &&
            header.value &&
            header.value !== ""
          ) {
            itemValue = String(itemValue).toLowerCase();
            const headerValueToString = String(header.value).toLowerCase();

            if (itemValue.indexOf(headerValueToString) === -1) {
              return true;
            }
          }
          return false;
        });

        if (headerFilterAreNotMatching) {
          return false;
        }

        return true;
      });
    }

    const tableStyle = computed(() => {
      let style = "grid-template-columns: ";

      const allGridSizes = props.headers
        .map((header) => header.gridSize)
        .join("fr ");
      style += allGridSizes + "fr;";
      return style;
    });

    watch(toRefs(props).items, () => {
      filterItems();
    });

    onMounted(() => {
      filterItems();
    });

    return {
      filteredItems,
      selectedItemIndex,
      highlightItem,
      filterItems,
      tableStyle,
    };
  },
});
</script>
